import React from 'react';
import Input from './Input';
export default function EmailInput(props) {
    return React.createElement(Input, Object.assign({ type: 'email' }, props));
}
//# sourceMappingURL=EmailInput.js.map